export default {
  DESCRIPTON_MAX_LENGTH: 200,
  SANS_MARQUE: "SANS MARQUE",
  PS: "PS"
}
